import { Box, Container, Grid, Typography, useMediaQuery, useTheme, Link } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import colors from "../theme/colors";

export default function Footer() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const year = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                mt: "auto",
                bgcolor: "grey.900",
                color: "white",
                py: 4,
            }}
        >
            <Container>
                <Grid container spacing={2} sx={{ justifyContent: "center", alignItems: "center" }}>

                    {!isMobile && (
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Box display="flex" flexDirection="column" alignItems="center" sx={{ my: 1 }}>
                                <Typography
                                    variant="h4"
                                    noWrap
                                    sx={{
                                        fontFamily: "'Arizonia', cursive",
                                        fontWeight: 400,
                                        letterSpacing: '.1rem',
                                        color: colors.background,
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => navigate('/')}
                                >
                                    Lawendowy dotyk
                                </Typography>
                                <Typography
                                    variant="h6"
                                    noWrap
                                    sx={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 400,
                                        letterSpacing: '.1rem',
                                        color: colors.background,
                                        textDecoration: 'none',
                                    }}
                                >
                                    dla zdrowia i ciała
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography variant="h6">Godziny otwarcia</Typography>
                        <Typography variant="body2">Pn–Pt: 6:00 – 18:00</Typography>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, justifyContent: "center" }}>
                            <PhoneIcon sx={{ mr: 1 }} />
                            <Link
                                href="tel:+48512208653"
                                underline="hover"
                                color="inherit"
                                sx={{ cursor: "pointer" }}
                            >
                                +48 512 208 653
                            </Link>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, justifyContent: "center" }}>
                            <LocationOnIcon sx={{ mr: 1 }} />
                            <Link
                                href="https://maps.app.goo.gl/581baiv3t3V5WLz89"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                color="inherit"
                                sx={{ cursor: "pointer" }}
                            >
                                ul. Łagiewnicka 85, Łódź
                            </Link>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Box
                            sx={{
                                textAlign: "center",
                                mt: 2,
                                pt: 2,
                            }}
                        >
                            <Typography variant="body2">
                                © {year} Lawendwy dotyk dla zdrowia i ciała. Wszystkie prawa zastrzeżone.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
